/**
 * @fileoverview Utility for merging Tailwind CSS classes
 * @example
 * cn("px-2 py-1", condition && "bg-red-500", "text-white")
 */

import classnames, { Argument as ClassnamesArgument } from "classnames";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassnamesArgument[]): string {
  return twMerge(classnames(...inputs));
}
